import React from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import capitalizeFirstLetter from 'shared-utils/src/capitalizeFirstLetter';

import PencilIcon from 'shared-vectors/icons/Pencil';
import { Icon } from 'shared-vectors';

import {
  getSearchWhat,
  getUsableFilters,
  getUsableLocations,
  getFiltersResume,
} from '../../utils';

import style, { lineCls, goToQbCls } from './style';

const useStyles = createStyle(style);

const SearchDetails = ({
  locations,
  filters,
  activeNearby,
  poiNamesList,
  sectionTitleCls,
  auctionFilter,
  isMobile,
  goToQb,
}) => {
  const usableFilters = getUsableFilters(filters, auctionFilter);

  const {
    mainLocation,
    secondaryLocation,
    tertiaryLocation,
    activePoi,
  } = getUsableLocations({
    locations,
    nearby: activeNearby,
    poi: usableFilters.poi,
    poiNamesList,
  });

  const filtersResume = getFiltersResume(usableFilters);
  const cls = useStyles();

  const detailCls = makeClassName([
    cls[lineCls],
    'mb--ls',
    'tp-s--m tp-w--s',
    'c-txt--secondary',
    'tp--ell',
  ]);

  return (
    <>
      <p className={sectionTitleCls}>RIEPILOGO</p>
      <div className="pt--ms pr--m pb--ms pl--ms c-bg--w b-r--m b--s is-rel is-clickable" onClick={goToQb}>
        <p className={detailCls}>Cerco <strong className="tp-w--l c-txt--secondary">{capitalizeFirstLetter(getSearchWhat(usableFilters.propertyTypeGroup || 'case', usableFilters.propertyTypes || []))}</strong></p>
        <p className={detailCls}>in <strong className="tp-w--l c-txt--secondary">{capitalizeFirstLetter(usableFilters.channel || 'vendita').replace('-breve', ' breve')}</strong></p>
        {mainLocation && <p className={detailCls}>{mainLocation}</p>}
        {secondaryLocation && <p className={detailCls}>{secondaryLocation}</p>}
        {tertiaryLocation && <p className={detailCls}>{tertiaryLocation}</p>}
        {activePoi && <p className={detailCls}>{activePoi}</p>}
        {filtersResume.length > 0 && filtersResume.map((filter, index) => <p key={`filter_${index}`} className={detailCls}>{filter}</p>)}
        <div className={`${cls[goToQbCls]} c-txt--f3 c-bg--tr is-clickable`} >
          <Icon
            name={PencilIcon}
            heigth="10px"
            width="20px"
          />
        </div>
      </div>
    </>
  );
};

export default SearchDetails;

SearchDetails.propTypes = {
  locations: PropTypes.instanceOf(Array),
  filters: PropTypes.instanceOf(Object),
  activeNearby: PropTypes.instanceOf(Object),
  poiNamesList: PropTypes.instanceOf(Object),
  sectionTitleCls: PropTypes.string,
  isMobile: PropTypes.bool,
  goToQb: PropTypes.func,
};

SearchDetails.defaultProps = {
  locations: [],
  filters: {},
  activeNearby: {},
  poiNamesList: {},
  sectionTitleCls: '',
  isMobile: true,
  goToQb: () => {},
};
